<template
  v-loading="loading"
  element-loading-text="正在导出中"
  element-loading-spinner="el-icon-loading"
  element-loading-background="rgba(0, 0, 0, 0.8)"
>
  <div class="app-container">
    <!--查询组-->
    <div class="filter-container">
      <!-- <el-input v-model="listQuery.company_name" placeholder="请输入公司简称" clearable style="width: 200px;" class="filter-item" @change="SearchData" @keyup.enter.native="SearchData" /> -->
      <!-- <el-select v-if="current_user.is_system == 1" v-model="listQuery.merchant_id" class="filter-item" clearable filterable placeholder="请选择门店名称" @change="changeMerchants">
        <el-option v-for="item in merchants" :key="item.id" :label="item.realname" :value="item.id"></el-option>
      </el-select> -->
      <el-select v-model="listQuery.type" class="filter-item" clearable filterable placeholder="订单类型">
        <el-option label="场地" value="1"></el-option>
        <el-option label="教练" value="2"></el-option>
        <el-option label="会员卡" value="3"></el-option>
        <el-option label="套餐" value="4"></el-option>
        <el-option label="余额充值" value="5"></el-option>
      </el-select>
      <el-select v-model="listQuery.payment_type" class="filter-item" clearable filterable placeholder="请选择支付方式">
        <el-option label="微信" value="1"></el-option>
        <el-option label="余额" value="2"></el-option>
        <el-option label="套餐" value="3"></el-option>
      </el-select>
      <div class="block" style="display: inline-block;margin-bottom: 10px;vertical-align: middle;">
        <el-date-picker
          v-model="listQuery.year"
          type="year"
          placeholder="选择年"
          value-format="yyyy"
        >
        </el-date-picker>
      </div>
      <el-select v-model="listQuery.month" style="width:180px;" placeholder="选择月" class="filter-item">
        <el-option label="全部" value=""></el-option>
        <el-option label="1月" value="01"></el-option>
        <el-option label="2月" value="02"></el-option>
        <el-option label="3月" value="03"></el-option>
        <el-option label="4月" value="04"></el-option>
        <el-option label="5月" value="05"></el-option>
        <el-option label="6月" value="06"></el-option>
        <el-option label="7月" value="07"></el-option>
        <el-option label="8月" value="08"></el-option>
        <el-option label="9月" value="09"></el-option>
        <el-option label="10月" value="10"></el-option>
        <el-option label="11月" value="11"></el-option>
        <el-option label="12月" value="12"></el-option>
      </el-select>
      <el-select v-model="listQuery.order_type" placeholder="查询类型" class="filter-item">
        <el-option label="成交额" :value="1"></el-option>
        <el-option label="交易量" :value="2"></el-option>
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
      <el-button class="filter-item" type="success" icon="el-icon-download" @click="OutData">导出</el-button>
    </div>
    <!--动作组-->
    <div class="action-container">
      <!-- <el-button-group>
        <el-button v-auth="'studyCategory.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
      </el-button-group> -->
      <span style="margin-right:10px;">总计金额<span style="color:red;font-size:18px;">{{ total_result.total_money||0 }}</span>元</span>
      <span style="margin-right:10px;">优惠金额（折扣）<span style="color:red;font-size:18px;">{{ total_result.discount_money||0 }}</span>元</span>
      <span>{{ listQuery.order_type == 1 ? '成交额' : '交易量' }}：<span style="color:red;font-size:18px;">{{ listQuery.order_type == 1 ? total_result.money||0 : total_result.total||0 }}</span>{{ listQuery.order_type == 1 ? '元' : '个' }}</span>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      fit
      border
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="goods_name"
        :label="listQuery.month ? '日期' : '月份'"
        show-overflow-tooltip
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ listQuery.month ? scope.row.day_show : scope.row.month_show }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goods_name"
        label="总收入"
        show-overflow-tooltip
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.total_money || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goods_name"
        :label="listQuery.order_type == 1 ? '成交额' : '交易量'"
        show-overflow-tooltip
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ listQuery.order_type == 1 ? scope.row.money : scope.row.total }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goods_name"
        label="优惠金额"
        show-overflow-tooltip
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.discount_money || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" prop="ratio" label="所占比例(%)">
        <template slot-scope="scope">
          <span>{{ listQuery.order_type == 1 ? scope.row.ratio_money : scope.row.ratio_total }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="ratio" label="">
        <template slot-scope="scope">
          <el-progress :text-inside="true" :stroke-width="24" :percentage="listQuery.order_type == 1 ? Number(scope.row.ratio_money) : Number(scope.row.ratio_total)"></el-progress>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
  </div>
</template>

<script>
import api from '@/api/finance' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import { mapGetters } from 'vuex'
export default {
  name: 'FinanceMoney',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      fromstatus: false,
      checkid: [],
      floor_number: false,
      edifices: [], // 大厦信息
      loading: false,
      // 额外过滤条件
      listQuery: {
        year: '',
        month: '',
        order_type: 1,
        payment_type: '',
        type: ''
      },
      total_result: {},
      discount_money: 0,
      merchants: [], // 商家列表
      merchants_id: '' // 商家id
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  created() {
    var now = new Date()
    this.listQuery.year = String(now.getFullYear())// 得到当前年份
    this.loadData() // 页面加载创建时加载数据
    this.getMerchants() // 获取商户信息
    if (this.current_user.is_system !== 1) {
      this.merchants_id = this.current_user.id
    }
    if (this.merchants_id) {
      this.getdictionary() // 获取订餐时段
    }
  },
  methods: {
    // 获取商家信息
    getMerchants() {

    },
    // 商家选择改变
    changeMerchants(newVal) {
      if (newVal != null && newVal !== '') {
        if (this.listQuery.operate_type != null) {
          this.listQuery.operate_type = ''
        }
        if (this.listQuery.reserve_type != null) {
          this.listQuery.reserve_type = ''
        }
        this.merchants_id = newVal
        this.getdictionary() // 分类
      } else {
        this.merchants_id = ''
        this.listQuery.operate_type = ''
        this.listQuery.reserve_type = ''
      }
    },
    // 加载数据表
    loadData() {
      if (this.listQuery.year === '' || this.listQuery.year === null) {
        var now = new Date()
        this.listQuery.year = String(now.getFullYear())// 得到当前年份
      }
      // 请求前处理
      this.loadListBefore(this.QueryParams)
      this.api.QueryMoney(this.listQuery).then(response => {
        this.listLoading = false
        this.list = response.data
        this.total_result = response.total_result
        this.discount_money = response.discount_money
      })
    },
    // 获取多选的数据
    handleSelectionChange(val) {
      this.multipleSelection = val// 存储选中的数据
    },
    // 批量导出
    OutData() {
      this.loading = true
      api.GetAllMoneyList(this.listQuery).then(res => {
        this.loading = false
        window.open(res.data)
        this.$notify({ title: '成功', message: '财务统计数据导出成功', type: 'success', duration: 2000 })
      })
    }
  }
}
</script>
